import { createFileRoute, redirect } from '@tanstack/react-router';

// /brain → default to the Ask tab.
export const Route = createFileRoute('/_app/brain/')({
  beforeLoad: () => {
    throw redirect({ to: '/brain/ask' });
  },
});
